module.exports = __webpack_public_path__ + "img/plusadd.2924f393.svg";